import React from 'react';

import PropTypes from 'prop-types';

const PAYLINE_WIDGET_SCRIPT_ID = 'payline-widget-script';
const PAYLINE_WIDGET_STYLE_ID = 'payline-widget-style';
const PAYLINE_FINAL_STATE_CALLBACK_NAME = '__lyriapayPaylineFinalState';
const PAYLINE_BEFORE_PAYMENT_CALLBACK_NAME = '__lyriapayPaylineBeforePayment';

const PAYLINE_WIDGET_ASSETS = {
    homologation: {
        script: 'https://homologation-payment.cdn.payline.com/cdn/scripts/widget-min.js',
        style: 'https://homologation-payment.cdn.payline.com/cdn/styles/widget-min.css',
    },
    production: {
        script: 'https://payment.cdn.payline.com/cdn/scripts/widget-min.js',
        style: 'https://payment.cdn.payline.com/cdn/styles/widget-min.css',
    },
};

const PaylineWebPaymentWidget = ({
    widgetToken,
    environment,
    template,
    onFinalState,
    onBeforePayment,
}) => {
    const widgetContainerRef = React.useRef(null);
    const assets = React.useMemo(() => {
        return environment === 'production'
            ? PAYLINE_WIDGET_ASSETS.production
            : PAYLINE_WIDGET_ASSETS.homologation;
    }, [environment]);

    React.useEffect(() => {
        if (typeof window === 'undefined') {
            return undefined;
        }

        window[PAYLINE_FINAL_STATE_CALLBACK_NAME] = (event) => onFinalState?.(event);
        window[PAYLINE_BEFORE_PAYMENT_CALLBACK_NAME] = (event) => onBeforePayment?.(event);

        return () => {
            delete window[PAYLINE_FINAL_STATE_CALLBACK_NAME];
            delete window[PAYLINE_BEFORE_PAYMENT_CALLBACK_NAME];
        };
    }, [onFinalState, onBeforePayment]);

    React.useEffect(() => {
        const styleEl = document.createElement('link');
        styleEl.id = PAYLINE_WIDGET_STYLE_ID;
        styleEl.rel = 'stylesheet';
        styleEl.href = assets.style;
        document.head.appendChild(styleEl);

        const scriptEl = document.createElement('script');
        scriptEl.id = PAYLINE_WIDGET_SCRIPT_ID;
        scriptEl.src = assets.script;
        scriptEl.async = true;
        document.head.appendChild(scriptEl);

        return () => {
            if (styleEl.parentNode) {
                styleEl.parentNode.removeChild(styleEl);
            }
            if (scriptEl.parentNode) {
                scriptEl.parentNode.removeChild(scriptEl);
            }
        };
    }, [assets.script, assets.style]);
    return (
        <div
            id="PaylineWidget"
            ref={widgetContainerRef}
            data-token={widgetToken}
            data-template={template}
            data-auto-init="true"
            data-embeddedredirectionallowed="true"
            data-event-finalstatehasbeenreached={PAYLINE_FINAL_STATE_CALLBACK_NAME}
            data-event-beforepayment={PAYLINE_BEFORE_PAYMENT_CALLBACK_NAME}
        />
    );
};

PaylineWebPaymentWidget.propTypes = {
    widgetToken: PropTypes.string.isRequired,
    merchantReturnUrl: PropTypes.string.isRequired,
    environment: PropTypes.oneOf(['homologation', 'production']),
    template: PropTypes.string,
    force3dsRedirect: PropTypes.bool,
    onFinalState: PropTypes.func,
    onBeforePayment: PropTypes.func,
};

PaylineWebPaymentWidget.defaultProps = {
    environment: 'production',
    template: 'column',
    force3dsRedirect: false,
    onFinalState: null,
    onBeforePayment: null,
};

PaylineWebPaymentWidget.displayName = 'PaylineWebPaymentWidget';

export default PaylineWebPaymentWidget;
